import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.css';

class CustomHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ascSort: false,
      descSort: false,
      noSort: false,
    };
    props.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    this.onMenuClicked = this.onMenuClicked.bind(this);
    this.onSortRequested = this.onSortRequested.bind(this);
    this.onClickHeaderCheckbox = this.onClickHeaderCheckbox.bind(this);
  }

  componentDidMount() {
    this.onSortChanged();
  }

  onSortChanged() {
    this.setState({
      ascSort: this.props.column.isSortAscending(),
      descSort: this.props.column.isSortDescending(),
      noSort: !this.props.column.isSortAscending() && !this.props.column.isSortDescending(),
    });
  }

  onMenuClicked() {
    this.props.showColumnMenu(this.menuButton);
  }

  onClickHeaderCheckbox(e) {
    e.preventDefault();
    this.props.onSelectAll(!this.props.selectedAll);
  }

  onSortRequested(event) {
    if (this.props.enableSorting) {
      let order = 'desc';
      if (this.state.descSort) {
        order = 'asc';
      } else if (this.state.ascSort) {
        order = null;
      }
      this.props.setSort(order, event.shiftKey);
    }
  }

  render() {
    const {
      enableMenu,
      displayName,
      enableSorting,
      showCheckbox,
      column: {
        colDef: { colId, type, cellRendererParams },
      },
      selectedAll,
    } = this.props;
    const { ascSort, descSort, noSort } = this.state;
    const sfColumn = cellRendererParams ? cellRendererParams.column : null;
    const displayHeaderName = cellRendererParams
      ? cellRendererParams.displayHeaderName
      : null;
    const description = sfColumn ? sfColumn.description : null;
    const rightAlign = type === 'numericColumn';
    const hasDescription =
      description !== undefined &&
      description !== null &&
      description.length > 0;
    const tipIcon = hasDescription ? (
      <span>
        <OverlayTrigger
          placement='top'
          overlay={
            <Tooltip id={`${colId}-description`}>
              <div style={{ whiteSpace: 'pre-line' }}>{description}</div>
            </Tooltip>
          }>
          <Fa name='info-circle' className='text-active' />
        </OverlayTrigger>
      </span>
    ) : null;

    let menu = null;
    if (enableMenu) {
      menu = (
        <div 
          ref={(menuButton) => {
            this.menuButton = menuButton;
          }}
          className="ag-header-icon ag-header-cell-menu-button"
          onClick={this.onMenuClicked}
        >
          <Fa name='bars' />
        </div>
      );
    }

    let sort = null;
    
    const label = displayHeaderName || displayName;
    
    const displayComp = rightAlign ? (
      <span>
        {tipIcon} {label}
      </span>
    ) : (
      <span>
        {label} {tipIcon}
      </span>
    );

    


    let labelComp = (<div className={`customHeaderLabel ${styles.header}`}>{displayComp}</div>);

    if (enableSorting) {
      if (ascSort || descSort) {
        sort = (
          <span>
            &nbsp; <Fa name={ascSort ? 'long-arrow-down' : 'long-arrow-up'} />
          </span>
        );
      }
      labelComp = (
        <span
          role='button'
          tabIndex='-1'
          className={styles.label}
          onClick={this.onSortRequested}
        >
          {displayComp}
        </span>
      );
    }


    let headerCheckboxDiv = null;
    if (showCheckbox) {
      let checkboxCls = '';
      if (selectedAll) {
        checkboxCls = 'checked';
      } else {
        checkboxCls = 'unchecked';
      }
      if (this.props.indeterminate) {
        checkboxCls = 'indeterminate';
      }
      headerCheckboxDiv = (
        <div style={{ float: 'left' }}>
          <span style={{ marginRight: '0.8em' }} className={`ag-icon ag-icon-checkbox-${checkboxCls}`} onClick={this.onClickHeaderCheckbox} />
        </div>
      );
    }

    return (
      <div className="ag-cell-label-container">
        {menu}
        <div className="ag-header-cell-label">
          {headerCheckboxDiv}
          {labelComp}
          {' '}
          {sort}
          {' '}
        </div>
      </div>
    );
  }
}

CustomHeader.propTypes = {
  displayName: PropTypes.string,
  column: PropTypes.shape({
    colDef: PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string,
      colId: PropTypes.string,
      cellRendererParams: PropTypes.shape({
        column: PropTypes.shape({
          description: PropTypes.string,
        }),
        displayHeaderName: PropTypes.string,
      }),
    }).isRequired,
    isSortDescending: PropTypes.func,
    isSortAscending: PropTypes.func,
    addEventListener: PropTypes.func,
  }).isRequired,
  setSort: PropTypes.func,
  enableMenu: PropTypes.bool,
  enableSorting: PropTypes.bool,
  showColumnMenu: PropTypes.func,
  onSelectAll: PropTypes.func,
  showCheckbox: PropTypes.bool,
  indeterminate: PropTypes.bool,
  selectedAll: PropTypes.bool,
};
CustomHeader.defaultProps = {
  displayName: null,
  setSort: () => {},
  enableMenu: false,
  enableSorting: false,
  showColumnMenu: () => {},
  onSelectAll: () => {},
  showCheckbox: false,
  indeterminate: false,
  selectedAll: false,
};

export default CustomHeader;
